import { Box, Flex, Show, Text } from "@chakra-ui/react";
import BaseImage from "@components/BaseImage";
import UTMLink from "@components/UTMLink";
import { CLAIM_GAIN_NUDGE } from "@constants/analytics";
import useVaultOverview from "@hooks/useVaultOverview";
import useYieldVaultData from "@hooks/useYieldVaultData";
import React from "react";
import { getUrlForLocalImage, trackEvent } from "utils";

type TGainOpportunitiesCard = {
  title: string;
  logo: string;
  apy: string;
  divider?: string;
};

const GainNudge = () => {
  const { formattedApy } = useVaultOverview();
  const { formattedApy: yieldApy } = useYieldVaultData();

  const renderDesktopView = () => {
    return (
      <Flex
        bgColor={"#EBF9F9"}
        borderRadius={"12px"}
        // border={"1px solid #A2CBCB"}
        mt="8px"
        padding={{ base: "16px", md: "14px 16px" }}
        cursor={"pointer"}
        gap="5"
        backgroundImage={getUrlForLocalImage("/assets/gain_nudge.png")}
        bgRepeat={"no-repeat"}
        bgPos={"right"}
      >
        <GainItem
          title="Airdrop Gain"
          logo="/assets/agETH.png"
          apy={formattedApy}
          divider="horizontal"
        />
        <GainItem
          title="High Gain"
          logo="/assets/vaults/hgeth.svg"
          apy={yieldApy}
        />
        <EarnRewardsBtn />
      </Flex>
    );
  };

  const renderMobileView = () => {
    return (
      <Flex
        bgColor={"#EBF9F9"}
        borderRadius={"12px"}
        mt="8px"
        padding={{ base: "16px", md: "24px" }}
        gap="5"
        direction={"column"}
      >
        <GainItem
          title="Airdrop Gain"
          logo="/assets/agETH.png"
          apy={formattedApy}
          divider="vertical"
        />
        <GainItem
          title="High Gain"
          logo="/assets/vaults/hgeth.svg"
          apy={yieldApy}
        />
        <EarnRewardsBtn />
      </Flex>
    );
  };

  return (
    <Box m={{ base: "16px", md: "24px 0 0 0" }}>
      <Text
        fontSize={{ base: "12px", md: "14px" }}
        lineHeight={{ base: "20px", md: "20px" }}
        fontWeight={400}
      >
        Earn upto ~20% APR or 7+ Airdrops with your rsETH!
      </Text>
      <UTMLink href={"/gain"} onClick={() => trackEvent(CLAIM_GAIN_NUDGE)}>
        <Show above="md">{renderDesktopView()}</Show>
        <Show below="md">{renderMobileView()}</Show>
      </UTMLink>
    </Box>
  );
};

const GainItem = ({ title, logo, apy, divider }: TGainOpportunitiesCard) => {
  const extraProps = divider
    ? divider === "horizontal"
      ? { borderRight: "1px solid #B6DFDF" }
      : { borderBottom: "1px solid #B6DFDF" }
    : {};
  return (
    <Flex justifyContent={"space-between"} gap="8px" pr="5" {...extraProps}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justifyContent={"space-between"}
        gap="10px"
        flex={1}
      >
        <Flex
          alignItems={"center"}
          justifyContent={{ base: "center", md: "flex-start" }}
          gap="6px"
          pt={{ base: divider ? "6px" : 0, md: 0 }}
          pb={{ base: divider ? "20px" : 0, md: 0 }}
        >
          <BaseImage src={logo} width={20} height={20} alt={""} />
          <Text
            fontSize={{ base: "12px", md: "14px" }}
            lineHeight={{ base: "20px", md: "20px" }}
            fontWeight={400}
          >
            {title} {`(upto ${apy} APY)`}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default GainNudge;

const EarnRewardsBtn = () => {
  return (
    <Text
      padding={"8px 12px"}
      width={{ base: "100%", md: "140px" }}
      fontSize={"12px"}
      fontWeight={600}
      backgroundColor="#075A5A"
      color="white"
      _hover={{
        backgroundColor: "#075A5A",
        color: "white",
      }}
      textAlign={"center"}
      alignSelf={"center"}
      borderRadius="0.5rem"
    >
      Earn Top Rewards
    </Text>
  );
};
